(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ergometric-quantity-discounts"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ergometric-volume-offer')) {
    customElements.define('ergometric-volume-offer', class extends HTMLElement {
      connectedCallback() {
        this.onVariantUpdate = (event) => {
          if (String(event.detail?.data?.productId) !== this.dataset.productId) return;
          const html = event.detail.data.html;
          const next = html?.querySelector(`ergometric-volume-offer[data-product-id="${this.dataset.productId}"]`);
          if (next) this.innerHTML = next.innerHTML;
        };
        document.addEventListener('variant:update', this.onVariantUpdate);
      }
      disconnectedCallback() {
        document.removeEventListener('variant:update', this.onVariantUpdate);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
